import { withRouter } from 'react-router'
import AllSegments from 'containers/AllSegments'

export default withRouter(AllSegments)
